import angular from "angular";
import {Util} from "@common/util";
import {IAppRootScopeService} from "@app/app.definition";
import {CacheService} from "@common/service/cache.service";
import {PopUpService} from "@common/popup/popup.service";
import {PushNotificationService} from "@common/service/push-notification.service";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {PaymentService} from "@common/service/payment.service";
import {PasswordCollectorService} from "@common/passwordCollector/services/passwordCollector.service";
import {UserService} from "@common/service/user.service";
import {SubjectService} from "@common/service/subject.service";
import {DocumentFolderService} from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import {TeamPermissionService} from "@common/service/teamPermission.service";
import {SnackbarService} from "@common/service/snackbar.service";
import {WebSocketService} from "@common/service/web-socket.service";
import {ValidationService} from "@common/service/validation.service";
import {IMultipleUploadService} from "@common/uploadDocuments/services/multipleUpload.service";
import {IBroadcastService} from "@common/service/broadcast.service";
import {DocumentService} from "@common/service/document.service";
import {TeamService} from "@common/service/team.service";
import {CommonService} from "@common/common.service";
import {TeamInvitationService} from "@common/service/team.invitation.service";
import {Subject} from "@common/model/subject";
import {ICachingService} from "@common/service/caching.service";

//module eCareVault {

export class AppService {
    init: Function;
    showTeamInvitationAlert: Function;
    addFileReaderPolyfill: Function;
    openFormerTeamAlertPopup: Function;
    openCurrentSubscriptionPopup: Function;
    addRecipient: Function;
    promptForVaultKey: Function;
    setSubjectInMemory: Function;
    displayPopUpNotifications: Function;
    user: any;
    processRequests: Function;
    processSentRequests: Function;
    openSentRequestPopup: Function;
    initTeamSelection: Function;
    showPostLoginPopups: Function;
    isSplashScreenOpen: boolean;
    logoutTimeOut: Function;

    static $inject = ["$q", "$state", "$http", "$rootScope", "$timeout", "CacheService",
        "PopUpService", "TeamInvitationService", "PushNotificationService",
        "ApiAdapterService", "PaymentService", "PasswordCollectorService", "Idle",
        "UserService", "SubjectService", "CachingService", 'is_iPad', 'DocumentFolderService',
        'TeamPermissionService', 'SnackbarService', 'WebSocketService', 'ValidationService',
        'BroadcastService', 'MultipleUploadService', 'DocumentService', 'TeamService', "storageConfig",
        "CommonService", "ecareEnv"];

    constructor(
        $q: angular.IQService,
        $state: angular.ui.IStateService,
        $http: angular.IHttpService,
        $rootScope:IAppRootScopeService,
        $timeout: angular.ITimeoutService,
        CacheService:CacheService,
        PopUpService:PopUpService,
        TeamInvitationService : TeamInvitationService,
        PushNotificationService:PushNotificationService,
        ApiAdapterService:JavaApiAdapterService,
        PaymentService:PaymentService,
        PasswordCollectorService:PasswordCollectorService,
        Idle: any,
        UserService:UserService,
        SubjectService:SubjectService,
        $_caching: ICachingService,
        is_iPad: boolean,
        DocFolderService:DocumentFolderService,
        $_teamPerm:TeamPermissionService,
        $_snack:SnackbarService,
        WebSocketService:WebSocketService,
        ValidationService:ValidationService,
        BroadcastService:IBroadcastService,
        MultipleUploadService:IMultipleUploadService,
        $_document : DocumentService,
        TeamService : TeamService,
        storageConfig : any,
        CommonService : CommonService,
        ecareEnv: string
    ) {
        const appServiceVm: any = this;


        this.showTeamInvitationAlert = () => {
            if (!!$rootScope.callPendingInvAlert) {
                $rootScope.callPendingInvAlert = false;
                if ($rootScope.pendingActiveInvitations > 0) {
                    const loggedInUser = CacheService.getUser();
                    let inv_msg = Util.PENDING_INVITATIONS_MSG.replace('$firstName', loggedInUser.firstName);
                    let suffix = $rootScope.pendingActiveInvitations > 1 ? "new invitations" : "a new invitation";
                    inv_msg = inv_msg.replace('$suffix', suffix);
                    PopUpService.openInformationModal(inv_msg).then(() => {
                        $rootScope.openTeamInvitations();
                    }, (e) => {
                        console.log(e);
                    });
                }
            }
        };

        this.addFileReaderPolyfill = () => {
            if (FileReader.prototype.readAsBinaryString === undefined) {
                FileReader.prototype.readAsBinaryString = function (fileData) {
                    let binary = "";
                    const pt = this;
                    const reader = new FileReader();
                    reader.onload = function () {
                        const bytes = new Uint8Array(reader.result as ArrayBuffer);
                        const length = bytes.byteLength;
                        for (let i = 0; i < length; i++) {
                            binary += String.fromCharCode(bytes[i]);
                        }
                        pt.content = binary;
                        $(pt).trigger('onload');
                    }
                    reader.readAsArrayBuffer(fileData);
                }
            }
        };

        this.openFormerTeamAlertPopup = (formerSubjects, formerTeamNotification) => {
            PopUpService.OpenFormerTeamAlertPopUp(formerSubjects, formerTeamNotification);
        };

        this.openCurrentSubscriptionPopup = () => {
            const deferred = $q.defer();
            ApiAdapterService.getCurrentSubscribePlanForUser(false).then((s) => {
                CacheService.setUserPlanType(s.planType);
                CacheService.setMaxCncrntDwnld(s.maxConcurrentDownloads);
                CacheService.setMaxCombineDocs(s.maxCombineDocuments);
                $rootScope.planType = s.planType;
                deferred.resolve(s);
            }, (e) => {
                deferred.reject(e);
            });
            return deferred.promise;
        };

        this.promptForVaultKey = () => {
            if (!!CacheService.getPassword()) {
                CacheService.setPassword(null);
                PasswordCollectorService.openPasswordModal(false, null, null, true).then(
                    () => {
                        clearTimeout(appServiceVm.logoutTimeOut);
                        Idle.watch();
                    });
            }
        }

        this.setSubjectInMemory = () => {
            const sub = CacheService.getCurrentSubject();
            if (!!sub) {
                CacheService.setCurrentSubjectInMemory(sub);
            } else {
                CacheService.setCurrentSubjectInMemory(null);
            }
        }

        this.showPostLoginPopups = () => {
            if (!this.isSplashScreenOpen) {
                this.isSplashScreenOpen = true;
                const handlePopups = () => {
                    this.showTeamInvitationAlert();
                    this.displayPopUpNotifications();
                    this.isSplashScreenOpen = false;
                };

                ApiAdapterService.getMessages()
                    .then((messageResponse: any) => {
                        const hasMessages =
                            messageResponse &&
                            messageResponse.messages &&
                            messageResponse.messages
                                .length > 0;

                        if (hasMessages) {
                            PopUpService.openSplashScreen(messageResponse)
                                .finally(() => {
                                    handlePopups();
                                });
                        } else {
                            handlePopups();
                        }
                    })
                    .catch((error: any) => {
                        console.error(
                            'Error fetching messages:',
                            error
                        );
                        handlePopups();
                    });
            }
        }


        this.displayPopUpNotifications = () => {
            const deferred = $q.defer();
            const response = {};

            // does user have any notification to show
            if (this.user.userNotifications && this.user.userNotifications.length > 0) {
                // does user have any notification type exitteam
                const formerTeamNotification = this.user.userNotifications.filter(function (el) {
                    return el.notificationType == 'EXITTEAM';
                });

                if (formerTeamNotification.length > 0) {
                    const totalSubs = CacheService.getTotalSubjects();
                    const filter = {
                        "isFormerTeamMember": true
                    };
                    ApiAdapterService.getSubjectsV3(0, totalSubs, null, filter).then(data => {
                        const former = {};
                        former['formerSubjects'] = data['subjects'];
                        if (former['formerSubjects'] && former['formerSubjects'].length > 0) {
                            appServiceVm.openFormerTeamAlertPopup(former, formerTeamNotification[0]);
                        }
                    })
                }
            }

            ApiAdapterService.getTransferOwnershipRequest(null).then(
                (s) => {
                    const ownershipRequestReceived = s.received;
                    const ownershipRequestSent = s.sent;
                    appServiceVm.processRequests(ownershipRequestReceived).then(
                        () => {
                            appServiceVm.processSentRequests(ownershipRequestSent);
                        }
                    );
                },
                e => {
                    console.log('error transfer request get: ' + e);
                }
            );

            appServiceVm.openCurrentSubscriptionPopup().then((s) => {
                response['planType'] = s.planType;
                response['maxCR'] = s.maxCR;
                deferred.resolve(response);
            }, (e) => {
                console.log(e);
            });
            return deferred.promise;
        };

        this.processRequests = (ownershipRequestReceived) => {
            const deferred = $q.defer();
            if (ownershipRequestReceived && ownershipRequestReceived.length > 0) {
                for (let request of ownershipRequestReceived) {
                    PopUpService.ConfirmOwnershipModal(request, 'request').then(s => {
                        if (s) {
                            ApiAdapterService.getSubject(request.subjectId, null).then(
                                (s) => {
                                    SubjectService.updateSubject(s.subjectId, {"ownerId": s.ownerId});
                                });
                        }
                    });
                }
            }
            deferred.resolve('success');
            return deferred.promise;
        };

        this.processSentRequests = (ownershipRequestSent) => {
            if (ownershipRequestSent && ownershipRequestSent.length > 0) {
                for (let request of ownershipRequestSent) {
                    appServiceVm.openSentRequestPopup(request);
                }
            }
        };

        this.openSentRequestPopup = (requestObj) => {
            const deferred = $q.defer();

            //ownership request accepted
            if (requestObj.status === 1 && !requestObj.isDeleted) {
                ApiAdapterService.updateOwnershipRecord(requestObj, true).then(
                    () => {
                        if (!!requestObj.exitTeam) {
                            PopUpService.ConfirmOwnershipModal(requestObj, 'requestAccepted');
                        } else {
                            let subjType = "the " + requestObj.projectName + " project";
                            if (requestObj.subjectTypeId == "INDIVIDUAL") {
                                subjType = requestObj.subjectName + "'s";
                            }
                            let msg = Util.TEAM_CAPTAIN_TRANSFER_SUCCESSFULLY.replace('$subject', subjType);
                            msg = msg.replace('$user', requestObj.invitedMemberName);
                            PopUpService.openInformationModal(msg);
                        }
                    },
                    () => {
                        console.log("Error while transferring ownership request " + requestObj);
                    }
                );
            }
            //ownership request declined
            if (requestObj.status === 2 && !requestObj.isDeleted) {
                let subject = {};
                ApiAdapterService.getSubject(requestObj.subjectId, null).then(
                    (s) => {
                        subject = s;
                        ApiAdapterService.getTeamMembers(requestObj.subjectId, null).then(
                            (s) => {
                                let owner = s.find((tm) => tm.captain)
                                subject['teamMemberList'] = s;
                                PopUpService.OpenTransferOwnershipModal(owner, subject, true, requestObj).then(() => {
                                }, (e) => {
                                    console.log(e);
                                });
                            }
                        );
                    }
                );
            }

            //sent reminder if exceeds more than 10 days
            if (requestObj.status === 0 && !requestObj.isDeleted) {
                const totalReminderDays = Util.days_between_dates(new Date(requestObj.invitedDate), new Date());

                if (totalReminderDays > 10) {
                    PopUpService.ConfirmOwnershipModal(requestObj, 'reminder');
                }
            }

            //if Team Member exited from team and owner sends owner transfer request to same Team Member
            if (requestObj.status === 3 && !requestObj.isDeleted) {
                PopUpService.ConfirmOwnershipModal(requestObj, 'teamMemberExited');
            }

            deferred.resolve('success');
            return deferred.promise;
        };

        this.initTeamSelection = () => {
            if (!CacheService.getCurrentSubject()) {
                let allSubs = angular.copy(CacheService.getSortedSubjects());
                if (allSubs.length == 1) {
                    $rootScope.selectChild(allSubs[0], true);
                } else if (allSubs.length == 0) {
                    $rootScope.selectChild(-1);
                }
            }
        }

        this.init = () => {
            this.user = CacheService.getUser();
            this.initTeamSelection();
            this.addFileReaderPolyfill();
            this.setSubjectInMemory();

            $rootScope.callPendingInvAlert = !!$rootScope.callPendingInvAlert || false;


            $rootScope.showSolidBg = !!window.sessionStorage["ecvInvite"];

            Idle.watch();

            if (Util.getIEVersion() != -1) {
                $rootScope.bodyClass = 'ie';
            } else if (is_iPad) {
                $rootScope.bodyClass = 'ipad';
            } else if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints <= 1) {
                $rootScope.bodyClass = 'safari';
            } else if (window.navigator.userAgent.indexOf("Edge") > -1) {
                $rootScope.bodyClass = 'edge';
            } else if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
                //if it is chrome browser
                $rootScope.bodyClass = 'notie chrome';
            } else {
                $rootScope.bodyClass = 'notie';
            }

            MultipleUploadService.userLoggedOut = false;
            $rootScope.getTeamActions(true);

            angular.element('.mainBody').off('click');
            angular.element('.mainBody').click(function (event) {
                if (!angular.element(event.target).closest('.cr-profile').length) {
                    BroadcastService.broadcast('save-cr-profile');
                }
                let target = event.target;
                if ((angular.element(target).closest('.build-team-container').length && target.classList.value.includes("cancel-button")) ||
                    (angular.element(target).closest('.organize-container').length && target.classList.value.includes("cancel-btn")) ||
                    (angular.element(target).closest('.connect-container').length && target.classList.value.includes("cancel-btn"))) {
                    if (!CacheService.getCurrentSubject()) {
                        $rootScope.forceCRSelection();
                    }
                }
            });

            BroadcastService.registerCallBack('push-notification-popover-open', $rootScope.$id, (element) => {
                $('#team-invitation-popover').popover('hide');
            });

            BroadcastService.registerCallBack('search-popover-open', $rootScope.$id, () => {
                $('#team-invitation-popover').popover('hide');
            });

            $rootScope.$on('$destroy', function () {
                BroadcastService.removeCallBack('push-notification-popover-open', $rootScope.$id);
                BroadcastService.removeCallBack('search-popover-open', $rootScope.$id);
            });

            $timeout(function () {
                $('#team-invitation-popover').on('show.bs.popover', function () {
                    $rootScope.$broadcast('team-popover-open', '#team-invitation-popover');
                });
                let frame = document.getElementById('ifrm-download');
                if (frame) {
                    CommonService.fetchSasToken().then(sassData => {
                         (frame as HTMLIFrameElement).src = storageConfig.url + "/" + (ecareEnv == "my" ? Util.DOWNLOAD_IFRAME_ORIGIN_MY : Util.DOWNLOAD_IFRAME_ORIGIN) + Util.DOWNLOAD_IFRAME_TAIL + "?" + sassData.sasToken;
                    });
                }
            }, 3000);
        }

        $rootScope.$on('IdleTimeout', function () {
            if (!!CacheService.getUser()) {
                appServiceVm.promptForVaultKey();
                appServiceVm.logoutTimeOut = setTimeout(() => {
                    // After 15m of idle session user is being navigated to the Vault key screen
                    // As per HIPPA, after 45m of idle session, user should be signed out
                    console.log("You have been on VK screen for more than 30m, So, logging you out...");
                    $rootScope.logout();
                }, 30 * 60 * 60 * 1000);
            }
        });

        $rootScope.addRecipient = () => {
            let enableMultipleTeam = CacheService.getFeatures().multipleTeam;
            const deferred = $q.defer();
            PaymentService.checkLimitAndProceed("team", () => {
                $rootScope.selectChild(-1);
                if (!enableMultipleTeam) {
                    $state.go('parent-addrecipient', {}, {reload: true});
                } else {
                    $state.go('parent-addmultiplesubject', {}, {reload: true});
                }
                deferred.resolve();
            });
            return deferred.promise;
        }

        $rootScope.openCRDropDown = () => {
            $timeout(() => {
                angular.element(".global-cr-height md-autocomplete input").focus();
                angular.element(".global-cr-height md-autocomplete").click();
            }, 200);
        };

        $rootScope.forceCRSelection = () => {
            $rootScope.openCRDropDown();
            toastr.success(Util.PLEASE_SELECT_CR, '', {timeOut: 3000});
        };

        $rootScope.clearAllNotifications =  () => {
            //function to filter out all notifications and clear the cache
            const func =  () => {
                return false;
            }
            PushNotificationService.markAllNotificationAsRead([{"id": 0}], func);
            $_document.updateEntityViewed(null, null, true);
        };

        $rootScope.openTeamInvitations = () => {
            $timeout(function () {
                angular.element("#invitation-icon").click();
            });
        };

        $rootScope.selectChild = (child, hideSnackbar?: boolean) => {
            const deferred = $q.defer();
            SubjectService.setCurrentSubject(child == -1 ? null : (child as Subject));
            if (child == -1) {
                if (!!CacheService.getCurrentSubject()) {
                    CacheService.setPreviousSubject({
                        subjectId: CacheService.getCurrentSubject().subjectId
                    });
                } else {
                    CacheService.setPreviousSubject(null);
                }
                CacheService.setCurrentSubject(null);
                deferred.resolve(true);
            } else {
                CacheService.setCurrentSubject(child as Subject);
                deferred.resolve(true);
            }

            const feeds = {
                documents: [],
                posts: [],
                discussions: []
            };

            const lastLoadedTimes = {
                posts: 0,
                documents: 0,
                discussions: 0
            }

            child = (child == -1 ? null : (child as Subject));
            if (!hideSnackbar && !!CacheService.getPassword() && child && child.subjectTypeId == 'INDIVIDUAL' && child.firstName && child.firstName.length > 0) {
                toastr.success((child).fullName + " selected.", "", {timeOut: 1500});
            }
            if (!hideSnackbar && !!CacheService.getPassword() && child && child.subjectTypeId == 'PROJECT' && child.projectName && child.projectName.length > 0) {
                toastr.success(child.projectName + " project selected.", "", {timeOut: 1500});
            }

            CacheService.setLastLoadedFeedTime(lastLoadedTimes);

            $_caching.saveCachedFeeds(feeds);


            BroadcastService.broadcast('cr-selected');
            return deferred.promise;
        };

        $rootScope.getTeamActions = (initial?: boolean) => {
            const deferred = $q.defer();
            TeamInvitationService.getUserPendingInvitations().then(invitations => {
                $rootScope.pendingInvitations = invitations;
                $rootScope.pendingActiveInvitations = 0;
                for (let inv of invitations) {
                    if (!!inv.invitation && inv.invitation.status != 'EXPIRED') {
                        $rootScope.pendingActiveInvitations++;
                    }
                }
                const currentSubject = CacheService.getCurrentSubject();
                const selectedSubjectId = currentSubject ? currentSubject.subjectId : null;
                TeamInvitationService.getPendingTeamActions(selectedSubjectId).then(teamActions => {
                    $rootScope.teamInvitations = teamActions;
                    BroadcastService.broadcast('update-team-invitations', [(!!initial ? initial : false)]);
                    deferred.resolve();
                }).catch(() => {
                    deferred.reject();
                });
            }).catch(() => {
                deferred.reject();
            });
            return deferred.promise;
        }
    }
}

//}

angular.module('eCareVault')
    .service('AppService', AppService);
